module.exports = __webpack_public_path__ + "img/hero-mobile.a80957a9.png";